export default __webpack_public_path__ + "static/media/Helm of Infernal Zeal.a205fc21.jpg";